export { default } from './articleItem';
